import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Volumen",
  "use": "Volumen-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Volumen\"><path fill-rule=\"evenodd\" d=\"M13 21.667H1v20.666h12L37 63V1L13 21.667z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol